<template>
    <div class="DocumentDetailsHeaderActions">
        <span v-if="showUploadDate && uploadedAt" ref="uploadDate" class="DocumentDetailsHeaderActions__uploadDate">
            Upload Date:
            <LocalDate format="MM/DD/YYYY" :value="uploadedAt" />
        </span>

        <slot name="header-actions" />

        <Expandable
            v-if="documents.length > 0"
            class="DocumentDetailsHeaderActions__download"
            :menu-config="{ positionX: 'end', offsetY: -5 }"
            :menu-items="documents.map((doc, index) => ({
                label: `File ${index + 1}`,
                action: () => handleDownload(index),
            }))"
        >
            <template #trigger="{ toggle }">
                <NewButton
                    variant="flat"
                    color="secondary"
                    size="icon-sm"
                    @click="toggle"
                >
                    <EidIcon :icon-src="faDownload" />
                </NewButton>
            </template>
        </Expandable>
    </div>
</template>

<style lang="scss">
.DocumentDetailsHeaderActions {
    display: flex;
    align-items: center;
    margin-left: auto;
    gap: 20px;
    flex-shrink: 0;
    min-width: 0;

    &__uploadDate {
        font-size: 14px;
        display: flex;
        align-items: center;
        white-space: nowrap;
        gap: 10px;
    }

    &__download {
        display: flex;
        align-items: center;

        .Expandable__menu {
            margin-top: 0;
            right: 0;
        }
    }
}
</style>

<script lang="ts">
    import { Component, Prop, Vue } from '@evidentid/vue-property-decorator';

    import { faDownload } from '@fortawesome/free-solid-svg-icons';

    import EidIcon from '@evidentid/dashboard-commons/components/EidIcon/EidIcon.vue';
    import { LocalDate } from '@evidentid/dashboard-commons/components/LocalDate';
    import { VerificationDocument } from '@evidentid/gateway-api-client/src/models/submission-tprm/VerificationDocument.model';

    import Expandable from '@/components/expandable/Expandable.vue';
    import NewButton from '@/components/new-button/NewButton.vue';

    @Component({
        emits: [ 'download' ],
        components: {
            EidIcon,
            NewButton,
            LocalDate,
            Expandable,
        },
    })
    export default class DocumentDetailsHeaderActions extends Vue {
        private faDownload = faDownload;

        @Prop({ type: Array, required: true })
        private documents!: VerificationDocument[];

        @Prop({ type: String })
        private uploadedAt!: string;

        @Prop({ type: String })
        private email!: string;

        @Prop({ type: Boolean, default: true })
        private showUploadDate!: boolean;

        private handleDownload(index: number): void {
            this.$emit('download', index);
        }
    }
</script>
